import m from "mithril";
import MessageProvider from "../../../MessageProvider";
import { HotelDetail } from "../../../Models";
import HotelPhotoGridBanner from "../roomselection/HotelPhotoGridBanner";
import HotelOverviewComponent from "../roomselection/HotelOverviewComponent";
import LightBox from "../../common/lightbox/LightBox";


interface Attrs {
    messageProvider: MessageProvider,
    hotelDetails: HotelDetail,
    onViewMapRequested: () => void;
}

interface PhotoGalleryDialogOpen {
    photoUrls: string[]
}

type PhotoGalleryDialogState = 'hidden' | PhotoGalleryDialogOpen;

function HotelDetailsComponent(): m.Component<Attrs> {
    let photoGalleryDialogState: PhotoGalleryDialogState = 'hidden';
    let clickedImageIndex = 0;

    return {
        view(vnode) {
            let { hotelDetails, messageProvider, onViewMapRequested } = vnode.attrs;            
            return [
                m("div",{
                    class: "border-bottom shadow pb-3 rounded-25"
                },
                    [
                        m("div",
                            m(HotelPhotoGridBanner, {
                                photoUrls: hotelDetails.photoUrls,
                                onViewMore: () => {
                                    photoGalleryDialogState = { photoUrls: hotelDetails.photoUrls };
                                },
                                onPhotoClick: (index) => {
                                    clickedImageIndex = index;
                                    photoGalleryDialogState = { photoUrls: hotelDetails.photoUrls };
                                }
                            })
                        ),
                        m("div.p-3",
                            m(HotelOverviewComponent, {
                                hotelDetails: hotelDetails,
                                messageProvider: messageProvider,
                                onViewHotelLocationMap: function () {
                                    onViewMapRequested();
                                },
                                onViewImageSelected: function () {
                                }
                            })
                        )
                    ]
                ),

                m(LightBox, {
                    imageUrls: (photoGalleryDialogState != 'hidden') ?
                        (photoGalleryDialogState as PhotoGalleryDialogOpen).photoUrls : [],
                    show: photoGalleryDialogState != 'hidden',
                    initialImageIndex: clickedImageIndex,
                    onClose: () => {
                        photoGalleryDialogState = 'hidden';
                    }
                })
            ]
        }
    }
}

export default HotelDetailsComponent;

